module.exports = __webpack_public_path__ + "static/media/ThumbnailStill06.043b1108.png";